module.exports = __webpack_public_path__ + "img/39b0dd25933b2ac99ca206f6fa6a610e.png";